import { LOGIN_SUCCESS } from '../actions/types';
import { apiService } from '../../utils/apiRequest';

const loginLoggerMiddleware = (store) => (next) => async (action) => {
  // let reducers run first so state stays snappy
  const result = next(action);

  if (action.type === LOGIN_SUCCESS) {
    const { accessToken, userData } = action.payload;

    try {
      const baseUrl = process.env.REACT_APP_API_URL || '';
      const saveLogs = `${baseUrl.replace(/\/$/, '')}/saveTutorLoginDetails`;
      
      if (!userData || !Array.isArray(userData.franchise_list) || !userData.franchise_list[0]) {
        console.error('Cannot log login details: missing franchise data in userData');
        return result;
      }

      const primaryFranchise = userData.franchise_list[0];

      if (!primaryFranchise.tutor_id || !primaryFranchise.franchise_id) {
        console.error('Cannot log login details: tutor_id or franchise_id missing');
        return result;
      }

      const options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          tutor_id: primaryFranchise.tutor_id,
          franchise_id: primaryFranchise.franchise_id,
        }),
      };

      const response = await apiService(saveLogs, options);

      if (response.status === 'success') {
        console.log('Login details logged successfully');
      } else {
        console.error(
          'Failed to log login details:',
          response.message
        );
      }
    } catch (error) {
      console.error('Error while logging login details:', error);
    }
  }

  return result;
};

export default loginLoggerMiddleware;
